import { RootState } from 'store'

export const collectionPageSizeSelector = (state: RootState) => state.env.collectionPageSize
export const searchSizeSelector = (state: RootState) => state.env.searchSize
export const environmentSelector = (state: RootState) => state.env.environment
